export default "<canvas id=\"activeTanksDoughnutChart\" style=\"width: 100%;\"></canvas>";